/**
 * Utility function to merge CSS classes
 * Similar to clsx/classnames functionality
 */
export function cn(...classes) {
  return classes
    .filter(Boolean)
    .join(' ')
    .replace(/\s+/g, ' ')
    .trim();
}

/**
 * Creates a variant system for components similar to class-variance-authority
 */
export function createVariants(base, variants, defaultVariants = {}) {
  return function(props = {}) {
    let result = base;
    
    Object.keys(variants).forEach(variantKey => {
      const variantValue = props[variantKey] || defaultVariants[variantKey];
      if (variantValue && variants[variantKey][variantValue]) {
        result += ' ' + variants[variantKey][variantValue];
      }
    });
    
    if (props.className) {
      result += ' ' + props.className;
    }
    
    return result.replace(/\s+/g, ' ').trim();
  };
}
